import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WephoneTranslationModule } from '@wephone-translation';
import { FlexLayoutModule } from '@angular/flex-layout';

import { SessionRoutes } from './wephone-session.routing';
import { NotFoundComponent } from './not-found/not-found.component';
import { ErrorComponent } from './error/error.component';
import { ForgotComponent } from './forgot/forgot.component';
import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { EnterpriseSelectComponent } from './enterprise-select/enterprise-select.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { WephoneCommonModule } from '@wephone-common';
import { WephoneUtilsModule } from '@wephone-utils';
import { SigninService } from './service/signin.service';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { MatDialogModule } from '@angular/material/dialog';
// import { BrowserModule } from '@angular/platform-browser';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WephoneCoreModule } from '@wephone-core/wephone-core.module';

@NgModule({
  imports: [
    // CommonModule,
    // BrowserModule,
    // BrowserAnimationsModule,
    RouterModule.forChild(SessionRoutes),
    MatListModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatSelectModule,
    MatDialogModule,
    FlexLayoutModule,
    FormsModule,
    WephoneTranslationModule,
    WephoneUtilsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    WephoneCommonModule
  ],
  declarations: [
    NotFoundComponent,
    ErrorComponent,
    ForgotComponent,
    LockscreenComponent,
    SigninComponent,
    SignupComponent,
    EnterpriseSelectComponent,
    OnboardingComponent,
    SubscriptionComponent,
  ],
  providers: [
    SigninService
  ]
})
export class WephoneSessionModule { }
